// Canonical gear vocabulary for the gear-filtering feature.
//
// The 16 gear categories a musician physically brings — mirrors the
// backend gear_categories() helper (backend/equivalence_map_v0.py), in the
// same order. Human labels are pulled from the venue inventory taxonomy
// (inventoryTemplates.js) so both sides of the platform share one wording.

import { labelForCategory } from './inventoryTemplates';

// Keys MUST stay in sync with equivalence_map_v0.gear_categories().
export const GEAR_CATEGORY_KEYS = [
  'guitar_amp', 'bass_amp', 'drum_kit', 'cymbals',
  'mic_dyn_vocal', 'mic_condenser', 'mic_dyn_instr', 'mic_kick', 'mic_wireless',
  'di_active', 'di_passive', 'di_stereo',
  'monitor_wedge', 'iem', 'foh_console', 'keys_amp',
];

// [{ value, label }] for checkbox lists and filter groups.
export const GEAR_CATEGORIES = GEAR_CATEGORY_KEYS.map((value) => ({
  value,
  label: labelForCategory(value),
}));

// Short DM-Mono codes for compact card tags (e.g. "GTR AMP", "KICK").
const GEAR_SHORT = {
  guitar_amp: 'GTR AMP',
  bass_amp: 'BASS AMP',
  drum_kit: 'DRUMS',
  cymbals: 'CYMB',
  mic_dyn_vocal: 'VOX MIC',
  mic_condenser: 'COND',
  mic_dyn_instr: 'INST MIC',
  mic_kick: 'KICK',
  mic_wireless: 'WL MIC',
  di_active: 'DI-A',
  di_passive: 'DI-P',
  di_stereo: 'DI-ST',
  monitor_wedge: 'WEDGE',
  iem: 'IEM',
  foh_console: 'FOH',
  keys_amp: 'KEYS AMP',
};

export const gearShortLabel = (category) => GEAR_SHORT[category] || labelForCategory(category);
export const gearLabel = (category) => labelForCategory(category);

// Categories the musician brings (brings:true), in canonical order.
export const broughtCategories = (gearProfile) => {
  const brought = new Set((gearProfile || []).filter((g) => g && g.brings).map((g) => g.category));
  return GEAR_CATEGORY_KEYS.filter((k) => brought.has(k));
};
